import { render, staticRenderFns } from "./TrainDetail.vue?vue&type=template&id=1ef124be&scoped=true&"
import script from "./TrainDetail.vue?vue&type=script&lang=js&"
export * from "./TrainDetail.vue?vue&type=script&lang=js&"
import style0 from "./TrainDetail.vue?vue&type=style&index=0&id=1ef124be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef124be",
  null
  
)

export default component.exports